/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class MonkeysGoldSoundConfig implements ISoundConfig {

    public static instance:MonkeysGoldSoundConfig = new MonkeysGoldSoundConfig();
    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";

    MONKEYS_GOLD_MAIN_GAME_AMBIANCE:string = "backgroundAmbience";

    REEL_SPIN_OUT:string = "reelsSpinOut";
    REEL_SPIN_IN:string = "reelsSpinIn";
    REELS_DEFAULT_BOUNCE:string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5", "reelLanding6", "reelLanding7", "reelLanding8", "reelLanding9", "reelLanding10", "reelLanding11"];
    // REELS_DEFAULT_STOP?:string[];
    DICE_START:string = "diceStart";
    DICE_ANTICIPATION:string = "diceAnticipation";
    DICE_ENDS:string = "diceEnds";
    SYMBOLS_HIGHLIGHT:string = "symbolsHighlight";
    SYMBOLS_UPGRADE:string = "symbolsUpgrade";
    SYMBOLS_LOCK:string = "symbolsLock";
    WIN_SWEEP_TINY_SMALL:string = "winSweepTinySmall";
    WIN_SWEEEP_MEDIUM:string = "winSweepMedium";
    WIN_SWEEP_LARGE:string = "winSweepLarge";
    COUNTUP:string = "countup";
    COUNTUP_ENDS_TINY:string = "countupEndsTiny";
    COUNTUP_ENDS_SMALL:string = "countupEndsSmall";
    COUNTUP_ENDS_MEDIUM:string = "countupEndsMedium";
    COUNTUP_ENDS_LARGE:string = "countupEndsLarge";
    BACKGROUND_MUSIC:string[] = ["mainMusic"];
    BONUS_GAME_MUSIC:string = "fsMusic";
    BIG_WIN_INITIAL_WIN:string = "bigwinInitialWin";
    BIG_WIN_LEVEL_1:string = "bigwinLevel1";
    BIG_WIN_LEVEL_2:string = "bigwinLevel2";
    BIG_WIN_LEVEL_3:string = "bigwinLevel3";
    BIG_WIN_ENDS:string = "bigwinEnds";
    SCATTER_1:string = "scatter1";
    SCATTER_2:string = "scatter2";
    SCATTER_3:string = "scatter3";
    MULTIPLIER_UP:string = "multiplierUp";
    MULTIPLIER_SWEEP:string = "multiplierSweep";
    COUNTUP_MULTIPLIER:string = "countupMultiplier";
    BIG_SYMBOL_LANDING:string = "bigSymbolLanding";
    WIN_SYMBOLS_LANDING:string = "winSymbolsLanding";
    FS_INTRO:string = "fsIntro";
    FS_OUTRO:string = "fsOutro";
    CONTINUE_BUTTON:string = "continueButton";
    FS_PLUS_SPIN:string = "fsPlusSpin";
    WILD_LANDING:string = "wildLanding";
    SCATTER_ANTICIPATION:string = "scatterAnticipation";
    SCATTER_ANTICIPATION_FAIL:string = "scatterAnticipationFail";
    SCATTER_ANTICIPATION_WIN_ENDS:string = "scatterAnticipationWinEnds";
    DICE_MULTIPLIER_SWEEP:string = "diceMultiplierSweep";
    SYMBOL_HIGHLIGHT:string = "symbolHighlight";
    BIG_SYMBOL_MULTIPLIER:string = "bigSymbolMultiplier";
    FLAMES_START:string = "flamesStart";
    FLAMES_LOOP:string = "flamesLoop";
    COUNTUP_ENDS_SWEEP:string = "countupEndsSweep";
    BIG_SYMBOL_TURNING:string = "bigSymbolTurning";

    constructor() {
        if(MonkeysGoldSoundConfig.instance) {
            throw new Error("MonkeysGoldSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}